// Note: types exposed from `index.d.ts`.
export {gfmFromMarkdown, gfmToMarkdown} from './lib/index.js'
